module.exports = __webpack_public_path__ + "img/telegram.9c809ee0.svg";